<template>
    <ButtonIcon v-if="uiStyle === 'chevron'"
        class="el--transparent ath-collapse-trigger"
        :icon="value ? 'chevron-down' : 'chevron-up'"
        @click.stop.prevent="toggle()" />
    <button v-else-if="uiStyle === 'arrows'"
        type="button"
        class="pr el-btn-icon el--s-s el--inline el--transparent ath-collapse-trigger"
        :class="[value ? 'el--right' : 'el--down']"
        @click.stop.prevent="toggle()"></button>
</template>

<script>
import ButtonIcon from './ButtonIcon.vue';

export default {
    name: 'mead-collapse-trigger',
    components: {ButtonIcon},
    props: {
        /**
         * Whether the associated section is currently collapsed (true) or
         * expanded (false). Toggled via `v-model` when the trigger is clicked.
         */
        value   : {type: Boolean, default: () => false},
        /**
         * Visual style of the trigger: 'chevron' renders a chevron ButtonIcon,
         * 'arrows' renders a plain button styled with a directional arrow.
         */
        uiStyle : {type: String, default: () => 'chevron'},
    },
    methods: {
        toggle: function () {
            this.$emit('input', !this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.el--down:before,
.el--right:before {
    content: '';
    position: absolute;
}

.el--down:before {
    top: 1.15rem;
    left: 1rem;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 9px solid var(--c-txt);
}

.el--right:before {
    left: 1.15rem;
    top: 1rem;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 9px solid var(--c-txt);
}
</style>
